export function userTransDown(role){
  switch (role){
    case 'MANAGER':role='manager';break;
    case 'SALES':role='saler';break;
    case 'PROJECT':role='project';break;
    case 'ANALYST':role='analyzer';break;
    case 'CUSTOMER':role='customer';break;
    case 'AUDITOR':role='auditor';break;
      break;
  }
  return role
}
export function userTransUp(role){
  switch (role){
    case 'manager':role='MANAGER';break;
    case 'saler':role='SALES';break;
    case 'project':role='PROJECT';break;
    case 'analyzer':role='ANALYST';break;
    case 'customer':role='CUSTOMER';break;
    case 'auditor':role='AUDITOR';break;
      break;
  }
  return role
}
